var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReduceWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0369 49.3889L51.4475 67.9259C51.4475 68.8566 49.5702 69.6111 47.2543 69.6111H13.7084C11.3926 69.6111 9.51518 68.8566 9.51518 67.9259L7.92578 49.3889H53.0369Z",
    fill: "#05F29B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90275 65.2954C7.90275 67.8935 9.92469 69.9997 12.4189 69.9997H48.5479C51.0421 69.9997 53.064 67.8935 53.064 65.2954L56.4511 13.5481H4.51562L7.90275 65.2954ZM6.92632 15.8061L10.156 65.1479C10.1592 65.197 10.1608 65.2462 10.1608 65.2954C10.1608 66.7342 11.2578 67.7416 12.4189 67.7416H48.5479C49.709 67.7416 50.806 66.7342 50.806 65.2954C50.806 65.2462 50.8076 65.197 50.8108 65.1479L54.0404 15.8061H6.92632Z",
    fill: "#1B1E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6894 9.03248C3.26573 9.03248 2.25806 10.1228 2.25806 11.2905V13.5486H58.7042V11.2905C58.7042 10.1228 57.6965 9.03248 56.2728 9.03248H4.6894ZM0 11.2905C0 8.79635 2.09952 6.77441 4.6894 6.77441H56.2728C58.8627 6.77441 60.9622 8.79635 60.9622 11.2905V15.8067H0V11.2905Z",
    fill: "#1B1E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9673 2.25806C24.7202 2.25806 23.7092 3.26903 23.7092 4.51613V6.77419H37.2576V4.51613C37.2576 3.26903 36.2467 2.25806 34.9996 2.25806H25.9673ZM21.4512 4.51613C21.4512 2.02194 23.4731 0 25.9673 0H34.9996C37.4937 0 39.5157 2.02194 39.5157 4.51613V9.03226H21.4512V4.51613Z",
    fill: "#1B1E59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3516 23.7097C29.3516 23.0861 29.857 22.5806 30.4806 22.5806V22.5806C31.1041 22.5806 31.6096 23.0861 31.6096 23.7097V59.8387C31.6096 60.4622 31.1041 60.9677 30.4806 60.9677V60.9677C29.857 60.9677 29.3516 60.4622 29.3516 59.8387V23.7097Z",
    fill: "#1B1E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7516 23.7832C16.7108 23.161 17.1821 22.6235 17.8043 22.5827V22.5827C18.4266 22.542 18.964 23.0133 19.0048 23.6355L21.3778 59.8405C21.4186 60.4627 20.9472 61.0002 20.325 61.041V61.041C19.7028 61.0817 19.1654 60.6104 19.1246 59.9882L16.7516 23.7832Z",
    fill: "#1B1E59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9574 23.6366C41.9982 23.0144 42.5357 22.543 43.1579 22.5838V22.5838C43.7801 22.6246 44.2514 23.1621 44.2106 23.7843L41.8376 59.9893C41.7969 60.6115 41.2594 61.0828 40.6372 61.042V61.042C40.015 61.0013 39.5436 60.4638 39.5844 59.8416L41.9574 23.6366Z",
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReduceWaste);
export default __webpack_public_path__ + "static/media/Icon_ReduceWaste.5c5aa9f0e73af616cec707b1171ed2d4.svg";
export { ForwardRef as ReactComponent };